import { call, put, takeEvery } from "redux-saga/effects";
import { deleteChatRequest, deleteChatSuccess, deleteChatFailure } from "../slice/deleteChatSlice";
import { deleteAllChat } from "@src/api/apiService"; // Implement this API function

export function* deleteChat(action: ReturnType<typeof deleteChatRequest>): Generator<any, void, any> {
    try {
        yield call(deleteAllChat); // action.payload is chatId
        yield put(deleteChatSuccess());
    } catch (error: any) {
        yield put(deleteChatFailure(error?.response?.data?.detail || error.message || "Unknown error"));
    }
}

export function* deleteChatSaga() {
    yield takeEvery(deleteChatRequest.type, deleteChat);
}
